import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { UiService } from '../../../services/ui.service';
import { Router } from '@angular/router';
import { FormHelper } from '../../../shared/form-helper';
import { TranslocoService } from '@ngneat/transloco';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';

@Component({
  selector: 'app-password-enter-email',
  templateUrl: './password-enter-email.component.html',
  styleUrls: ['./password-enter-email.component.scss']
})
export class PasswordEnterEmailComponent implements OnInit {

  public form: UntypedFormGroup = this.fb.group({
    email: new UntypedFormControl('', [Validators.required, CustomValidators.email()])
  });
  public errors = null;
  public busy = false;
  public messages: Array<any> = [];

  constructor(
    private fb: UntypedFormBuilder,
    private api: ApiService,
    private ui: UiService,
    private router: Router,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  public onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid) {
      this.busy = true;
      this.api.sendOnetimePassword(this.form.value.email).subscribe(
        (result: any) => {
          this.router.navigate(['/password/renew', this.form.value.email]);
        },
        () => {
          this.ui.showMessage('error', this.transloco.translate('password.error_on_password_send'), this.transloco.translate('common.error'));
        }
      ).add(() => {
          this.busy = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
